import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverBreakFilterEntity } from '../../domain/entities/DriverBreakFilterEntity'

export class DriverBreakFilterModel extends DriverBreakFilterEntity {
  driverId?: number
  regionId?: number

  constructor(dataDto: DriverBreakFilterEntity) {
    super()
    mapEntityProperties<DriverBreakFilterModel>(this, dataDto, {
      exclude: ['driver', 'region'],
      map: {
        driverId: dataDto.driver?.id,
        regionId: dataDto.region?.id
      }
    })
  }
}
